import { render } from "./InscriptionCourses.vue?vue&type=template&id=1dfc3075&scoped=true"
import script from "./InscriptionCourses.vue?vue&type=script&lang=js"
export * from "./InscriptionCourses.vue?vue&type=script&lang=js"

import "./InscriptionCourses.vue?vue&type=style&index=0&id=1dfc3075&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfc3075"]])

export default __exports__